'use client';

import { useContext } from 'react';
import Cart from 'components/gruenland/organisms/cart/Cart';
import { CartProps } from 'components/gruenland/organisms/cart/types';
import { AccountContext } from 'context/account';
import { useCart } from 'frontastic';
import { TasticProps } from '../../types';

const YggdrasilCartTastic = ({ data, categories }: TasticProps<CartProps>) => {
  const { login, requestConfirmationEmail, requestPasswordReset } = useContext(AccountContext);

  const {
    data: cart,
    isEmpty,
    hasOutOfStockItems,
    removeItem,
    updateItem,
    redeemDiscountCode,
    removeDiscountCode,
    totalItems,
  } = useCart();

  return (
    <Cart
      {...data}
      cart={cart}
      isEmpty={isEmpty}
      totalItems={totalItems}
      hasOutOfStockItems={hasOutOfStockItems}
      onApplyDiscountCode={redeemDiscountCode}
      onRemoveDiscountCode={removeDiscountCode}
      categories={categories}
      onRemoveItem={removeItem}
      onUpdateItem={updateItem}
      login={login}
      requestConfirmationEmail={requestConfirmationEmail}
      requestPasswordReset={requestPasswordReset}
    />
  );
};

export default YggdrasilCartTastic;
